import React, { useContext } from 'react'
import { useIntl } from 'react-intl'

// types
import { IconRegularChevronRight } from '@notino/react-styleguide'
import { ReservationResponse } from '../../../../types/types'

// utils
import { PAGE_LINKS } from '../../../../utils/helper'

// styles
import * as SC from './SalonInfoStyles'

// hooks
import useMessages from '../../../../hooks/useMessages'
import { AppContext } from '../../../../utils/appProvider'

type Props = {
	salonData: NonNullable<ReservationResponse['reservation']>['salon']
}

const SalonInfo = (props: Props) => {
	const { messages } = useMessages()
	const { locale } = useIntl()
	const { assetsPath } = useContext(AppContext)

	const { salonData } = props

	// eslint-disable-next-line global-require
	const fallbackImage = `${assetsPath}/${require('../../../../assets/images/basic-salon-placeholder.jpg')}`
	const salonImage = (salonData.images.find((image) => image.isCover) || salonData.images[0])?.resizedImages.medium || fallbackImage

	// TODO: tu je potrene aby BE doplnit salon-seo-slug
	return (
		<SC.SalonInfo $backgroundImage={salonImage} href={PAGE_LINKS['/salons/:salonSlug'](locale, salonData.seoSlugName)}>
			{salonData.logo && (
				<SC.SalonLogoWrapper>
					<img src={salonData.logo.resizedImages.small} alt={messages['Salon logo']} />
				</SC.SalonLogoWrapper>
			)}
			<SC.BottomArea>
				<SC.BottomAreaLeft>
					{salonData.name && <SC.SalonName>{salonData.name}</SC.SalonName>}
					{salonData.formattedAddress && <SC.SalonAddress>{salonData.formattedAddress}</SC.SalonAddress>}
				</SC.BottomAreaLeft>
				<IconRegularChevronRight width={'1.5rem'} height={'1.5rem'} color={'icon.inverse'} />
			</SC.BottomArea>
		</SC.SalonInfo>
	)
}

export default SalonInfo
